import { isBooleanFalse, isBooleanTrue, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";

export const SURVEY_FLOW_KEYS = Object.freeze({
    GOALS: 'GOALS',
    INTAKE: 'INTAKE',
    CONSULT: 'CONSULT',
    FOLLOW_UP: 'FOLLOW_UP',
});

export const normalizeSurveyFlowKey = (flowKey) => {
    if (!isStringNotEmpty(flowKey)) {
        return null;
    }

    const normalizedFlowKey = String(flowKey).trim().replace(/[\s-]+/g, '_').toUpperCase();
    if (normalizedFlowKey === 'FOLLOWUP') {
        return SURVEY_FLOW_KEYS.FOLLOW_UP;
    }

    return Object.values(SURVEY_FLOW_KEYS).includes(normalizedFlowKey) ? normalizedFlowKey : null;
};

export const getDuplicateSurveyFlowKeys = (surveyFlowItems = []) => {
    if (!Array.isArray(surveyFlowItems)) {
        return [];
    }

    const seenFlowKeys = new Set();
    const duplicateFlowKeys = new Set();
    surveyFlowItems.forEach((surveyFlowItem) => {
        const normalizedFlowKey = normalizeSurveyFlowKey(surveyFlowItem?.flowKey);
        if (isStringNotEmpty(normalizedFlowKey)) {
            if (seenFlowKeys.has(normalizedFlowKey)) {
                duplicateFlowKeys.add(normalizedFlowKey);
            } else {
                seenFlowKeys.add(normalizedFlowKey);
            }
        }
    });

    return Array.from(duplicateFlowKeys);
};

export const validateUniqueSurveyFlowKeys = (surveyFlowItems = [], context = 'Survey settings') => {
    const duplicateFlowKeys = getDuplicateSurveyFlowKeys(surveyFlowItems);
    if (duplicateFlowKeys.length > 0) {
        throw new Error(`${context} can only have one survey row per flow. Duplicate flow key(s): ${duplicateFlowKeys.join(', ')}.`);
    }

    return true;
};

class SurveyFlowItem {
    flowKey = null; // Enum SurveyFlowKeys
    surveyId = null;
    enabled = true;
    skippable = false;
    displayOrder = 0;

    constructor(surveyFlowItem, index = null) {
        if (isObjectNotEmpty(surveyFlowItem)) {
            const normalizedFlowKey = normalizeSurveyFlowKey(surveyFlowItem.flowKey);
            if (isStringNotEmpty(normalizedFlowKey)) { this.flowKey = normalizedFlowKey; }
            if (isStringNotEmpty(surveyFlowItem.surveyId)) { this.surveyId = surveyFlowItem.surveyId; }
            if (isBooleanFalse(surveyFlowItem.enabled)) { this.enabled = false; }
            else if (isBooleanTrue(surveyFlowItem.enabled)) { this.enabled = true; }
            if (isBooleanTrue(surveyFlowItem.skippable)) { this.skippable = true; }
            if (isNumberGreaterThanOrEqualToZero(surveyFlowItem.displayOrder)) { this.displayOrder = surveyFlowItem.displayOrder; }
            else if (isNumberGreaterThanOrEqualToZero(index)) { this.displayOrder = index + 1; }
        } else if (isNumberGreaterThanOrEqualToZero(index)) {
            this.displayOrder = index + 1;
        }
    }

    toDto = () => {
        return {
            flowKey: this.flowKey,
            surveyId: this.surveyId,
            enabled: this.enabled,
            skippable: this.skippable,
            displayOrder: this.displayOrder,
        };
    }
}

export const normalizeSurveyFlowItems = (surveyFlowItems = []) => {
    return Array.isArray(surveyFlowItems)
        ? surveyFlowItems.map((surveyFlowItem, index) => new SurveyFlowItem(surveyFlowItem, index).toDto())
        : [];
};

export default SurveyFlowItem;
